// The onboarding wizard's answer model, shared between the wizard itself
// (pages/onboarding) and the product-page banners that personalise from it.
//
// This is main's original single-answer shape: the radio probe, unchanged,
// with only the platform options swapped.

export type BuildChoice = 'voice-ai' | 'sip' | 'audio' | 'voice-api' | 'messaging'

// 'custom' is the bring-your-own answer (its free text rides in
// frameworkDetail); 'not-voice' is no longer OFFERED by the probe but stays in
// the union because orgs that answered it under the original wizard still have
// it stored, and their SIP/Audio banners stay suppressed on the strength of it
// (see isNotForVoiceAgents).
export type Framework = 'livekit' | 'pipecat' | 'openai' | 'xai' | 'gemini' | 'custom' | 'not-voice'

// Step 2's answer to "How did you hear about Plivo?". 'other' carries free text
// in acquisitionSourceDetail.
export type AcquisitionSource = 'search' | 'ai-assistant' | 'partner-docs' | 'community' | 'other'

export interface WizardState {
  build: BuildChoice | ''
  framework: Framework | ''
  // Free text for the "Custom stack" option (and stored 'not-voice' answers).
  frameworkDetail: string
  // The no-code path's follow-up ("What do you need the agent to handle?").
  // Free text, optional — qualification data, never a gate (see isComplete).
  agentDescription: string
  acquisitionSource: AcquisitionSource | ''
  acquisitionSourceDetail: string
}

export const INITIAL_WIZARD_STATE: WizardState = {
  build: '',
  framework: '',
  frameworkDetail: '',
  agentDescription: '',
  acquisitionSource: '',
  acquisitionSourceDetail: '',
}
